import React from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { getRoles } from '../services/userRights'

class MenuItem extends React.Component {
    isActiveLink() {
        if (this.props.entry.isActive) {
            return this.props.entry.isActive(this.props.match, this.props.location);
        } else {
            return this.props.location.pathname == this.props.entry.url;
        }
    }

    render(match, location) {
        if (this.props.entry.restrictRoles) {
            var userRoles = getRoles();

            var isAllowed = false;
            var restrictRoles = this.props.entry.restrictRoles;
            userRoles.forEach(function(userRole) {
                if (restrictRoles.includes(userRole)) {
                    isAllowed = true;
                }
            });

            if (!isAllowed) {
                return null;
            }
        }

        if (this.props.entry.itemType === 'file') {
            return (
                <li>
                    <a href={this.props.entry.url} target="_blank">
                        <i className={this.props.entry.className}></i>
                        <span>{this.props.entry.title}</span>
                    </a>
                </li>
            );
        } else if (this.props.entry.childs) {
            let location = this.props.location;
            let childs = this.props.entry.childs.map(function (entry, ind) {
                return <MenuItem key={ind} entry={entry} location={location} />
            });

            return (
                <li className="treeview">
                    <a href="#">
                        <i className={this.props.entry.className}></i>
                        <span>{this.props.entry.title}</span>
                        <span className="pull-right-container">
                            <i className="fa fa-angle-left pull-right"></i>
                        </span>
                    </a>
                    <ul className="treeview-menu">
                        {childs}
                    </ul>
                </li>
            );
        } else {
            let outerClassName = this.isActiveLink() ? "active" : "";
            return (
                <li className={outerClassName}>
                    <NavLink to={this.props.entry.url} isActive={this.props.entry.isActive}>
                        <i className={this.props.entry.className}></i>
                        <span>{this.props.entry.title}</span>
                    </NavLink>
                </li>
            );
        }

    }
}

export default compose(
    withRouter,
    connect()
)(MenuItem);


// WEBPACK FOOTER //
// ./App/menu/menuItem.jsx